import React from 'react';

import { Column, Line } from '@ant-design/charts';
import { Paper } from '@material-ui/core';
import moment from 'moment';


interface IProps {
    data: object[],
    mode?: 'column' | 'line'
}


const RevenueAnalyticsChart = (props: IProps) => {

    const data = props.data.map((d: any) => ({
        ...d,
        date: moment(d.date).format('L')
    }))

    const config = props.mode === 'column' ?
        {
            data: data,
            isStack: true,
            xField: 'date',
            yField: 'total',
            seriesField: 'advertiser',
            label: {
                position: 'top',
                layout: [
                    { type: 'interval-adjust-position' },
                    { type: 'interval-hide-overlap' },
                    { type: 'adjust-color' },
                ],
            },
        }
        : {
            data: data,
            xField: 'date',
            yField: 'total',
            point: {
                size: 5,
                shape: 'diamond',
            },
        };

    return (
        <Paper style={{ padding: 30 }}>
            {
                props.mode === 'column' ?
                    // @ts-ignore
                    <Column {...config} />
                    // @ts-ignore
                    : <Line {...config} />
            }
        </Paper>
    );
};

export default RevenueAnalyticsChart;
